<template>
  <div class="upload-id-photo">
    <div class="head">
      照片
      <fliggy-select-file-btn
        v-if="!forbidUploadIdPhoto"
        class="m-l-20"
        :order="order"
        :applicant="applicant"
        material-name="照片"
        :max-select-num="1"
        @confirm="onUploadPhotoByFliggy"
      ></fliggy-select-file-btn>
    </div>
    <div class="body">

      <!-- 上传 -->
      <upload-item :img-url="imgUrl" :upload="idPhoto" :forbid="forbidUploadIdPhoto"
        :verify-passed="idPhoto.id_photo_status === consts.PHOTO_STATUS.verifyPassed_0"
        :verify-not-pass="idPhoto.id_photo_status === consts.PHOTO_STATUS.verifyNotPassed_3"
        :is-reupload="isReupload"
        @saveUploadInputId="saveUploadInputId"
        @uploadFile="uploadIdPhoto"
        @reviewImage="reviewImage"
        ></upload-item>

      <!-- 分割线 -->
      <div class="dashed-line"></div>

      <!-- 示例 -->
      <!-- 照片的示例 sample 还是返的字符串 -->
      <sample class="sample-box" v-if="orderIdPhoto.sample" :sample-url="orderIdPhoto.sample" @click.native="reviewImage(orderIdPhoto.sample)"></sample>

      <!-- 注意事项放在第一项虽然不符合逻辑但是不会出问题，因为注意事项不会变化，且有利于余生不通过的展示 -->
      <attention class="attention-box" :class="{ 'more-space-for-none-sample': !orderIdPhoto.sample }" :attention="idPhotoTipsArr"></attention>
    </div>

    <!-- 资料不完善备注 -->
    <memo class="memo" v-if="idPhoto.memo" :memo-content="idPhoto.memo"></memo>

    <div v-if="canProvidePaper" class="foot">
      <el-checkbox v-model="selfProvideIdPhoto" @change="changeSelfProvideIdPhoto" :disabled="disableSelfProvide">自行提供纸质照片</el-checkbox>
    </div>
  </div>
</template>

<script>

import MessageModal from '@/components/common/modals/message-modal/message-modal';

import memo from './memo';
import attention from './attention';
import uploadItem from './upload-item';
import sample from './sample';
import utils from '../../libs/utils';
import Http from '../../libs/http';
import uploadFileService from '../../services/upload-file-service';
import orderService from '../../services/order-service';
import materialConstants from '../../constants/material-constants';
import applicantConstants from '../../constants/applicant-constants';
import uploadService from '../../services/upload-service';
import FliggySelectFileBtn from './ota/fliggy-select-file-btn.vue';

export default {
  name: 'UploadIdPhoto',
  components: {
    memo,
    attention,
    uploadItem,
    sample,
    FliggySelectFileBtn,
  },
  props: {
    idPhoto: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    orderIdPhoto: {
      type: Object,
      default() {
        return {};
      },
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    isReupload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selfProvideIdPhoto:
        this.idPhoto.dest_photo.indexOf('elec_material_by_offline') > -1, // 这个是如果走线下的时候，会用这张照片来代替
      consts: {
        PHOTO_STATUS: materialConstants.PHOTO_STATUS,
      },
      imgConfig: {
        ratio: 7 / 10,
        desc: ['两寸照片（50mmx35mm）', '无边框', '清晰彩照，白底照片', '6个月近照', '全脸免冠', '头部居中, 宽度(21mm-24mm), 高度(28mm-33mm)', '不可使用翻拍或扫描照片'],
        egImg: 'https://o.666visa.cn/static/application-auto/malaysia-photo.png',
        cropperClass: 'mala',
        fillcolor: ['#00bff3', '#ffffff', '#cc0001', '#999999'][this.orderIdPhoto.color], // 默认底色 [蓝，白，红]
      },
    };
  },
  computed: {
    imgUrl() {
      if (this.selfProvideIdPhoto) {
        return '';
      }
      return this.idPhoto.dest_photo;
    },

    // 照片要求
    idPhotoTipsArr() {
      const { color, height, width } = this.orderIdPhoto;
      const colorName = ['蓝', '白', '红', '灰'][color];
      const arr = [
        `${colorName}底，${width}×${height}mm`,
        '拍摄时注意光线均匀，不要佩戴眼镜，露出双耳',
        '请用纯色墙做背景，避免衣服与背景色相同',
        '手机拍摄的照片会经过程序检测并自动处理，请申请方提交订单前仔细检查照片是否为满足上述条件',
      ];
      return arr;
    },

    // 禁用自行提供纸质照片
    disableSelfProvide() {
      if (this.isReupload) {
        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return false;
        }

        const isApplicantVerifyNotPass =
          this.applicant.applicant_status ===
          applicantConstants.STATUS.verifyNotPassed_2;

        // 申请人不是资料不完善，不能点击
        if (!isApplicantVerifyNotPass) {
          return true;
        }
      }

      return (
        this.idPhoto.id_photo_status ===
        materialConstants.PHOTO_STATUS.verifyPassed_0
      );
    },

    // 是否可以上传照片
    forbidUploadIdPhoto() {
      // 如果已经选了自行邮寄纸质资料就直接禁用
      if (this.selfProvideIdPhoto) {
        return true;
      }

      // 重新上传的时候
      if (this.isReupload) {
        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return false;
        }

        const isApplicantVerifyNotPass =
          this.applicant.applicant_status ===
          applicantConstants.STATUS.verifyNotPassed_2;

        // 申请人不是资料不完善，不能上传
        if (!isApplicantVerifyNotPass) {
          return true;
        }

        return (
          this.idPhoto.id_photo_status ===
          materialConstants.PHOTO_STATUS.verifyPassed_0
        );
      }

      return false;
    },

    // 是否可以勾选自行提供纸质照片
    canProvidePaper() {
      if (!this.order.applicant) {
        return true;
      }
      let flag = false;
      // 整个订单里面，只要有一个申请人存在需要邮寄的资料，都可以勾选这个。
      this.order.applicant.forEach((ap) => {
        const material_optional = ap.material.material_optional;
        const material_required = ap.material.material_required;
        const masterial_all = [...material_required, ...material_optional];
        if (masterial_all.length > 0 && masterial_all.some(item => item.attr === 1)) {
          flag = true;
        }
      });

      return flag;
    },
  },
  methods: {
    /**
     * 切换自行提供纸质照片
     */
    changeSelfProvideIdPhoto(event) {
      const isOrderHaveExpressMaterial = orderService.isOrderHavePaperyMaterial(
        this.order,
      );

      // 重置函数
      const reset = () => {
        if (this.selfProvideIdPhoto) {
          this.selfProvideIdPhoto = false;
        }
      };

      if (isOrderHaveExpressMaterial) {
        if (event.target.checked) {
          utils.msgbox
            .confirm(
              '自行提供的纸质照片需符合签证办理要求，否则无法通过签证专家预审。确定仍然提供纸质照片？',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '再想想',
                type: 'warning',
              },
            )
            .then(() => {
              Http.post('/applicant_id_photo_special_handle', {
                action: 1,
                order_id: this.applicant.user_order_id,
                applicant_id: this.applicant.order_applicant_id,
              }).then(() => {
                this.idPhoto.dest_photo = '';
                this.idPhoto.id_photo_status =
                  materialConstants.PHOTO_STATUS.waittingForVerified_2;

                // 重新上传的时候
                if (this.isReupload) {
                  this.idPhoto.memo = '';
                }
                // 手动触发一下外部计算是否展示重新审核的弹窗，解决从有照片点击自行提供没有弹出重新审核的问题
                this.$emit('touchIfShowReVerifyBox');
              }).catch((e) => {
                if (e.msg && e.msg.indexOf('无需上传') > -1) {
                  setTimeout(() => {
                    location.reload();
                  }, 2000);
                }
                if (e) console.log(e);
              });
            }, reset);
        } else {
          Http.post('/applicant_id_photo_special_handle', {
            action: 0,
            order_id: this.applicant.user_order_id,
            applicant_id: this.applicant.order_applicant_id,
          }).then(() => {
            this.idPhoto.dest_photo = '';
            this.idPhoto.id_photo_status =
              materialConstants.PHOTO_STATUS.waittingForUploadMaterial_1;
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      } else {
        utils.msgbox
          .alert(
            '办理本签证不需要邮寄任何纸质资料，请务必上传电子照片。',
            '重要提示',
            {
              confirmButtonText: '知道了',
            },
          )
          .then(reset);
      }
    },

    // 飞猪上传证件照
    onUploadPhotoByFliggy({ key_list }) {
      const key = key_list[0];
      this.$set(this.idPhoto, 'loading', true);
      this.doUploadIdPhoto(key, 1, 'key');
    },

    // 上传证件照
    uploadIdPhoto(file, need_check = 1) {
      this.$set(this.idPhoto, 'loading', true);

      // 检测图片尺寸
      this.checkImgSize(file)
        .then(() => {
          this.doUploadIdPhoto(file, need_check);
        })
        .catch((err) => {
          if (err) console.log(err);
          this.$set(this.idPhoto, 'loading', false);
          // 有选择图片但是图片不符合要求
          if (err.choosed) {

            const h = this.$createElement;
            const msgList = ['照片像素低于400*400，有被使馆拒签和拒绝入境的风险，是否仍然上传？'].map(item => h('p', null, [
              h('i', { style: 'color: #FF4949;margin-right: 10px;', class: 'el-icon-circle-close' }, ''),
              h('span', { style: 'line-height: 22px;' }, item),
            ]));

            MessageModal.modal({
              title: '系统提示',
              message: h('div', null, msgList),
              confirmButtonText: '重新上传',
              cancelButtonText: '合格，仍然上传',
              showCancelButton: true,
              showConfirmButton: true,
              confirmMethod: () => {
                this.$parent.chooseFileAgain();
              },
              cancelMethod: () => {
                this.doUploadIdPhoto(file, need_check);
              },
            });
          }
        });
    },
    

    // 已经改了
    doUploadIdPhoto(file, need_check, fileType) {
      Promise.resolve(fileType === 'key' ? file : uploadFileService.uploadFile(file, false, { noKey: true })).then((res) => {
        uploadFileService.uploadIdPhoto(this.applicant.user_order_id, this.applicant.order_applicant_id, need_check, res, Number(this.isReupload), { noToast: true }).then((res) => {
          this.idPhoto.loading = false;
          this.idPhoto.dest_photo = res.url;

          // 这里是处理资料不完善的时候，要将状态改变和memo去除
          if (this.isReupload) {
            this.idPhoto.id_photo_status = materialConstants.PHOTO_STATUS.waittingForVerified_2;
            this.idPhoto.memo = '';
          }

          // 提示
          utils.msg.success('上传成功');
        }).catch((err) => {
          err = err.msg;

          this.$set(this.idPhoto, 'loading', false);
          // 错误提示
          const confirmButtonText = err.check_type ? '仍然上传' : '';
          const cancelButtonText = err.check_type ? '重新上传' : '知道了';
          const h = this.$createElement;

          if (!err.desc) {
            return utils.msg.error(err);
          }

          const msgList = err.desc.map(item => h('p', null, [
            h('span', null, item),
          ]));

          MessageModal.modal({
            title: '系统提示',
            message: h('div', null, msgList),
            showCancelButton: true,
            showConfirmButton: !!err.check_type,
            confirmButtonText,
            cancelButtonText,
            distinguishCancelAndClose: true,
            confirmMethod: () => {
              this.$msgbox({
                title: '提示',
                message: '上传未通过检测的照片，可能会被签证专家预审不通过，是否继续上传？',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: '继续上传',
                cancelButtonText: '再想想',
              }).then(() => {
                this.doUploadIdPhoto(file, 0, fileType);
              }).catch((e) => {
                if (e) console.log(e);
              });
            },
            cancelMethod: () => {
              this.$parent.chooseFileAgain();
            },
          });

        });
      });

    },


    // 预览图片
    reviewImage(imageSrc) {
      this.$emit('reviewImage', imageSrc);
    },
    saveUploadInputId(id) {
      this.$emit('saveUploadInputId', id);
    },

    // 验证图片宽高
    checkImgSize(file) {
      return new Promise(((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function (theFile) {
            const image = new Image();
            image.src = theFile.target.result;
            image.onload = function () {
              resolve();
              // if (this.width < 400 || this.height < 400) reject({ msg: 'choose image failed', choosed: true });
              // else resolve();
            };
          };
        } else {
          reject({ msg: 'choose image cancelled', choosed: false });
        }
      }));
    },
  },
  created() {
    if (this.idPhoto.id_photo_status === 2) {
      this.idPhoto.memo = '';
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";
.upload-id-photo {
  line-height: 1;
  background-color: white;
  margin-bottom: 10px;
  .head {
    padding: 30px 30px 20px 30px;
    font-size: 18px;
    color: @text-dark;
    display: flex;
    align-items: center;
  }
  .body {
    padding: 0 30px 20px 30px;
    display: flex;
    .dashed-line {
      width: 1px;
      height: 160px;
      background-color: white;
      border-right: 1px dashed @border;
      margin-left: 90px;
    }
    .sample-box {
      margin-left: 50px;
    }
    .attention-box {
      margin-left: 30px;
      flex: 1;
      &.more-space-for-none-sample {
        margin-left: 50px;
      }
    }
  }
  .memo {
    margin: 0 30px 20px 30px;
  }
  .foot {
    padding: 0 30px 30px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-id-photo.vue